export interface SalesOrderBalanceConfirmationReportLine {
  productKey: string;
  productDescription: string;
  makeUp: string;
  customerProduct: string;
  customerLineRef: string;
  quantity: number;
  despatchQty: number;
  toFollowQty: number;
  unit: number;
  price: number;
  priceListUnit: string;
  discount: number;
  value: number;
  deliveryDate: Date;
  currencySymbol: string;
  contractNumber: number;
  contractBalance: number;
}
